function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WizardTitle = function WizardTitle($scope, StateUtils, $state) {
    var _this = this;

    _classCallCheck(this, WizardTitle);

    this.$onInit = function () {
        var model = StateUtils.activeDataForState(true).model;
        $scope.productName = model.baseData.productName.value;
        $scope.accountNumber = model.baseData.accountNumber.value;

        $scope.isQuote = _this.isQuote;
        $scope.isPolicyChange = _this.isPolicyChange;
        $scope.isRenewal = _this.isRenewal;

        if ($scope.isRenewal) {
            $scope.transactionID = model.jobID.value;
            $scope.accountHolder = model.baseData.accountHolder.displayName.value;
            $scope.policyNumber = model.policyNumber.value;
        } else if ($scope.isPolicyChange) {
            $scope.transactionID = model.jobID.value;
            $scope.accountHolder = model.baseData.accountName.value;
            $scope.policyNumber = model.policyNumber.value;
        } else if ($scope.isQuote) {
            $scope.isQuotePortal = model.sessionUUID.value === undefined;
            $scope.quoteID = model.quoteID.value;
            $scope.accountHolder = model.baseData.accountHolder.value;

            $scope.$watch(function () {
                return $state.current.name;
            }, function (currentState) {
                $scope.currentState = currentState;

                var isAddBuildingWizard = currentState.includes('cpBuildingWizard') && !['cpBuildingWizardBuildingsList', 'cpBuildingWizardInitialScreen', 'cpBuildingWizardSpreadsheetScreen'].includes(currentState);
                $scope.isSideScreen = ['bopLocation', 'bopBuilding'].includes(currentState) || isAddBuildingWizard;

                $scope.isBOPBuildingEditing = Boolean($state.params.building);
            });
        }
    };
};

WizardTitle.$inject = ['$scope', 'StateUtils', '$state'];

export default WizardTitle;


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/components/transactionWizardTitle/transactionWizardTitleCtrl.js
// module id = 1315
// module chunks = 0